import { FC } from 'react';
import { getRouteApi } from '@tanstack/react-router';
import { TermsAndConditions } from '@frontend/digital-forms-ui';

const routeApi = getRouteApi('/legal/terms-conditions_/$locationId');

export const TermsAndConditionsPage: FC = () => {
  const { locationId } = routeApi.useParams();

  return <TermsAndConditions locationId={locationId} />;
};
